import AppStoreContext from 'contexts/AppStoreContext';
import ECSEditorContext from 'contexts/ECSEditorContext';
import { EditorTools } from 'editor/components/Tool';
import React, { useContext } from 'react';
import { Project } from 'records/Project';
import { PlacePunch } from 'records/interactions/PlacePunch';
import { useTranslator } from '@bluebeam/react-i18n';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';

const CreatePunchBtn: React.FC = () => {
  const { state: appState, actions } = useContext(AppStoreContext);
  const { projects, selectedProject, interactions } = appState;
  const project = projects.get(selectedProject, new Project());
  const { tool: toolComp } = useContext(ECSEditorContext);
  const { translate } = useTranslator(['mapView']);
  const { [FeatureFlag.AddPunchToDrawing]: isAddPunchToDrawingEnabled } =
    useFeatureFlags();

  const createPunchInteraction = interactions.find(
    (i) => i.type === 'CreatePunch'
  );

  const { createPunch } = project.permissions;

  function handleCreatePunchClick() {
    actions.clearInteractions();
    // show PlacePunch Overlay message & footer
    actions.createInteraction(new PlacePunch());
    toolComp.tool = EditorTools.CreatePunch;
  }

  return createPunch && isAddPunchToDrawingEnabled ? (
    <button
      data-testid="place-punch-btn"
      className="btn btn-primary"
      onClick={handleCreatePunchClick}
      disabled={!!createPunchInteraction}
      style={{ pointerEvents: 'auto' }}
    >
      {translate('mapView:buttons.placePunch')}
    </button>
  ) : null;
};

export default CreatePunchBtn;
